
import axios from 'axios'
import React, {useEffect, useState} from 'react'
import {useHistory, useParams} from 'react-router-dom'
import FormWrapper from '../../../../reusable-components/Wrapper/Wrapper'
import {MoonLoader} from 'react-spinners'
import {Box, Button} from '@mui/material'
import DynamicForm from '../../../../reusable-components/forms/DynamicForm'
import { WOUND_ENTRIES_CONSTANTS } from '../../../wound/WOUND_CONSTANTS'
import {toast} from 'react-toastify'
import ImagePickerScroller from '../../../../reusable-components/ImagePickerScroller/ImagePickerScroller'

const WoundCareNoteForm = () => {
  const {clientId, entryId, woundId}: {clientId: string; entryId: string; woundId: string} =
    useParams()
  const [formData, setFormData] = useState({})
  const [uiElements, setUiElements] = useState([])
  const [loading, setLoading] = useState(false)
  const history = useHistory()
  const [images, setImages] = useState<string[]>([])
  const [selectedFiles, setSelectedFiles] = useState<File[]>([])
  const [uploadedFileKeys, setUploadedFileKeys] = useState<string[]>([])
  const [existingImageUrls, setExistingImageUrls] = useState<string[]>([])
  const [urlToFileKeyMap, setUrlToFileKeyMap] = useState<Map<string, string>>(new Map())

  // Function to fetch presigned URLs for existing images
  const fetchPresignedUrl = async (fileKeys) => {
    try {
      const response = await axios.post('/batchfile/fetch-batch-urls', {
        fileKeys: fileKeys,
      })

      if (response.status === 200 && response.data.length > 0) {
        return response.data
      } else {
        throw new Error('No valid URL found for this file.')
      }
    } catch (err) {
      console.error('Error fetching presigned URL:', err.message)
      return null
    }
  }

  // Function to fetch all presigned URLs for existing images
  const fetchExistingImages = async (fileKeys: string[]) => {
    try {
      const presignedUrlsResponse = await fetchPresignedUrl(fileKeys)

      if (presignedUrlsResponse && Array.isArray(presignedUrlsResponse)) {
        // Extract URLs from the response objects
        const validUrls = presignedUrlsResponse
          .filter((item) => item && item.url)
          .map((item) => item.url)

        // Create mapping between URLs and file keys
        const urlToKeyMap = new Map()
        presignedUrlsResponse.forEach((item, index) => {
          if (item && item.url && fileKeys[index]) {
            urlToKeyMap.set(item.url, fileKeys[index])
          }
        })

        setExistingImageUrls(validUrls)
        setImages(validUrls) // Set initial images for ImagePickerScroller
        setUploadedFileKeys(fileKeys) // Store existing file keys
        setUrlToFileKeyMap(urlToKeyMap) // Store URL to file key mapping
      } else {
        console.error('Invalid response format from presigned URLs API')
        toast.error('Failed to load existing images - invalid response format')
      }
    } catch (error) {
      console.error('Error fetching existing images:', error)
      toast.error('Failed to load existing images')
    }
  }
useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      try {
        // Extract the actual ID value from the parameter string
        const actualEntryId = entryId.split('=')[1] || entryId;
        
        const response = await axios.get(`/wound-entries/getById/${actualEntryId}`, {
          params: {
            isDeleted: true,
          }
        });
        
        const {data} = response.data;
        
        const clientOption = {
          label: data.clientFullName, 
          value: data.clientId
        };
        
        const updatedclients = [clientOption];
        
        const actualClientId = clientId.split('=')[1] || clientId;
        const selectedClient = updatedclients.find((client) => client.value === actualClientId);
        
        setFormData({
          ...data,
          addrInfo: data.addressInfo,
        })
        
        // Modified mapping to conditionally disable all fields based on isDeleted status
        const updatedFormData = WOUND_ENTRIES_CONSTANTS.map((item) => {
          if (item.name === 'clientId') {
            return {
              ...item, 
              options: updatedclients, 
              disabled: true,  // Always disable clientId field
              value: selectedClient?.value
            }
          }
          // Disable all other fields if the entry is deleted
          return {
            ...item, 
            disabled: true  // Disable if entry is deleted
          }
        })
        
        setUiElements(updatedFormData)
        
        // Fetch existing images if they exist
        if (data.imageUrls && data.imageUrls.length > 0) {
          await fetchExistingImages(data.imageUrls)
        }
      } catch (error) {
        console.error('Error fetching data:', error)
        toast.error('Failed to fetch wound entry data')
      } finally {
        setLoading(false)
      }
    };
    
    fetchData()
  }, [entryId, clientId])

  const buttons = [
    {
      label: 'Cancel',
      variant: 'outlined',
      type: 'button',
    },
  ]
  return (
    <>
      {loading ? (
        <div className='overlay d-flex justify-content-center' style={{marginTop: '100px'}}>
          <MoonLoader color='#9db2fc' size={60} loading={loading} />
        </div>
      ) : (
        <FormWrapper
          title='Deleted Edit Wound Entry'
          content={
            <>
                <Button
                  variant='outlined'
                  color='primary'
                  onClick={() => history.goBack()}
                >
                  Back
                </Button>
              <div style={{marginBottom: '20px'}}>
                <div style={{fontSize: '12px', color: '#666', marginBottom: '10px'}}>
                  Maximum 10 images, each up to 10MB. Supported formats: JPG, PNG, GIF
                </div>
                <ImagePickerScroller
                  value={images}
                  setImageUrls={() => {}}
                  onFilesChange={() => {}}
                  maxVisible={5}
                  maxFiles={10}
                  maxFileSize={10 * 1024 * 1024} // 10MB
                  disabled={true} 
                />
              </div>
              <DynamicForm
                fields={uiElements}
                data={formData}
                onSubmit={() => {}}
                buttons={buttons}
                setFormValues={setFormData}
              />
            </>
          }
        />
      )}
    </>
  )
}

export default WoundCareNoteForm
